import { createRootRoute, Outlet } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <main className="app-shell">
      <section className="search-panel">
        <h1>Page not found</h1>
        <a href="/">Return to Kirtan Finder</a>
      </section>
    </main>
  ),
});
